// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import { BANK_TRANSFER, CHARITY } from '../../../../config/constants';
import PaymentTypeLabel from '../../../../components/PaymentTypeLabel/PaymentTypeLabel';
import { SearchCharityInput } from '../../../../components';


class Charity extends React.Component {
  renderCharityInfo = (classes) => {
    const { charities, selectCharityId } = this.props;
    const description = `Select from one of our chartiable partners
      to donate your payment and support their global programs.`;

    return (
      <div className={classes.infoContainer}>
        <span className={classes.subText}>{description}</span>
        <SearchCharityInput charities={charities} selectCharityId={selectCharityId} />
      </div>
    );
  }

  render() {
    const {
      text,
      classes,
      selectedPaymentType,
      setPaymentType,
    } = this.props;

    return (
      <PaymentTypeLabel
        type={CHARITY}
        text={text}
        showEditButton={false}
        selectedPaymentType={selectedPaymentType}
        setPaymentType={setPaymentType}
        renderPaymentTypeInfo={this.renderCharityInfo(classes)}
      />
    );
  }
}

Charity.propTypes = {
  classes: PropTypes.object,
  text: PropTypes.string,
  selectedPaymentType: PropTypes.number,
  setPaymentType: PropTypes.func,
  charities: PropTypes.array,
  selectCharityId: PropTypes.func,
};

Charity.defaultProps = {
  classes: {},
  text: '',
  selectedPaymentType: BANK_TRANSFER,
  setPaymentType: () => { },
  charities: [],
  selectCharityId: () => { },
};

export default withStyles(styles)(Charity);
